import {CustomerFactory} from "@connox/typescript-library";
import * as React from "react";
import {Suspense} from "react";
import * as ReactDOM from "react-dom";
import CartContextProvider, {
  isCart,
  useUnsafeCartContext,
} from "./components/cart/CartContextProvider/CartContextProvider";
import CustomerContextProvider from "./components/customer/CustomerContextProvider/CustomerContextProvider";
import * as Sentry from "@sentry/browser";
import {Cart} from "./components/cart/Cart/Cart";
import ListLoader from "./components/utils/loader/ListLoader";
import CartLoader from "./components/utils/loader/CartLoader";
import ShoppingCart from "./components/cart/ShoppingCart/ShoppingCart";
import {GatewayProvider} from "react-gateway";
import MediaQuery from "react-responsive";

export const init = (): void => {
  // This is the react root of our cart / application
  const cartElement = document.createElement("div");
  document.body.appendChild(cartElement);

  // region portals to everywhere

  // Element to render modal content in - outside of the dom to prevent css side effects
  const modalRootElement = document.createElement("div");
  modalRootElement.id = "ModalRootElement";
  document.body.appendChild(modalRootElement);

  const reactCartIcon: HTMLAnchorElement | null = document.querySelector("#CartIcon");
  if (reactCartIcon) {
    const cartIcon = document.createElement("span");
    cartIcon.classList.add("temp-cart-icon");
    cartIcon.style.display = "none";

    document.body.appendChild(cartIcon);
  }

  const addToCartButtonRoot = document.createElement("div");
  addToCartButtonRoot.id = "AddToCartButtonRoot";
  addToCartButtonRoot.style.display = "none";
  document.body.appendChild(addToCartButtonRoot);

  // endregion

  ReactDOM.render(<Cart />, cartElement);

  // region dedicated cart page

  const CartGuard: React.FC = (props) => {
    const context = useUnsafeCartContext();

    if (!isCart(context)) {
      return null;
    }

    return <React.Fragment>{props.children}</React.Fragment>;
  };

  const reactCart: HTMLElement | null = document.querySelector("#Cart");
  if (reactCart !== null && reactCart.parentElement !== null) {
    ReactDOM.render(
      <CustomerContextProvider>
        <CartContextProvider>
          <CartGuard>
            <Suspense
              fallback={
                <div className="ShoppingCart flexx">
                  <MediaQuery query="not all and (min-width: 768px)">
                    <ListLoader />
                  </MediaQuery>
                  <MediaQuery query="(min-width: 768px)">
                    <div style={{flexDirection: "row"}}>
                      <CartLoader />
                    </div>
                  </MediaQuery>
                </div>
              }
            >
              <GatewayProvider>
                <ShoppingCart />
              </GatewayProvider>
            </Suspense>
          </CartGuard>
        </CartContextProvider>
      </CustomerContextProvider>,
      reactCart.parentElement,
    );
  }

  // endregion

  // region customer log in and out hack

  const customerLogin: HTMLElement | null = document.querySelector(".submit-button");
  if (customerLogin !== null) {
    customerLogin.addEventListener("click", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();

      const form = (evt.target as HTMLButtonElement).form as HTMLFormElement;
      const username = (form.Email as HTMLInputElement).value;
      const password = (form.Password as HTMLInputElement).value;

      if (username === null || password === null) {
        return;
      }

      CustomerFactory.getCustomer().then((customer) => {
        customer.logIn({username, password}).then(() => {
          window.location.reload();
        }, Sentry.captureException);
      }, Sentry.captureException);
    });
  }

  const customerLogout: HTMLAnchorElement | null = document.querySelector(".button.logout-button");
  if (customerLogout !== null) {
    CustomerFactory.getCustomer().then((customer) => {
      customerLogout.addEventListener("click", (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        CustomerFactory.clearCustomer();
        customer.logOut().then(() => {
          window.location.reload();
        }, Sentry.captureException);
      });
    }, Sentry.captureException);
  }

  // endregion
};
